import React, { Component, Fragment } from 'react';
import CheckBox from '~/js/components/CheckBox';

class FeatureType extends Component {
  render() {
    const { features, activeFeatures, disabled } = this.props;

    return (
      <Fragment>
        <h3 className="list-title">By Unique Features</h3>
        <ul className="feature-list">
          {features.map((item, index) => {
            return (
              <li key={item.questionText} data-id={item.questionId} className={disabled.includes(item.questionId) ? ' disabled' : ''}>
                <CheckBox
                  label={`${item.questionText}`}
                  classNames="checkbox"
                  onChange={(e) => this.props.featureChange(e, item, 'feature')}
                  isChecked={activeFeatures.includes(item.questionId) && !disabled.includes(item.questionId)}
                  isDisabled={disabled.includes(item.questionId)}
                />
              </li>
            );
          })}
        </ul>
      </Fragment>
    );
  }
}

export default FeatureType;